import ReportAPI from 'apis/ReportAPI';
import compileReports from 'mappers/exports/CompileReports';

/**
 * Load codes v codes report in chunks to handle large datasets
 * @param {string} projectId - The project ID
 * @param {Array} codes - Array of code objects
 * @returns {Promise} - Compiled report data
 */
export async function loadChunkedCodesVCodesReport(projectId, codes, trackingContext = null) {
  if (!codes || codes.length === 0) {
    return { report: { codes: {} } };
  }

  const code_ids = codes.map(code => code.id || code.server_id);
  const reports = [];
  const chunkSize = 200;
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  for (let i = 0; i < code_ids.length; i += chunkSize) {
    // Add delay between chunks to avoid overwhelming the server
    if (i > 0) {
      await delay(2000);
    }

    // If total codes is less than chunk size, send null to get all codes
    // Otherwise, send a slice of code IDs
    const code_ids_slice = code_ids.length < chunkSize
      ? null
      : code_ids.slice(i, i + chunkSize);

    // Flag only the first chunk so the controller logs the export exactly once.
    const requestContext = i === 0 ? { ...(trackingContext || {}), logExport: true } : trackingContext;

    try {
      const result = await ReportAPI.getCodesVCodesReport(projectId, code_ids_slice, 'or', requestContext);
      reports.push({
        code_ids: code_ids_slice,
        data: result.data
      });
    } catch (error) {
      console.error(`Error fetching report for code_ids: ${code_ids_slice}`, error);
      // Re-throw to handle in mutation's error handler
      throw error;
    }
  }
  
  // Compile all chunks into a single report
  return compileReports(reports);
}